import { Create, ListButton, TopToolbar } from 'react-admin';

import ChevronLeft from '@material-ui/icons/ChevronLeft';

import ReferenceTypeForm from './ReferenceTypeForm';

const ReferenceTypeActions = ({ basePath }: any) => (
  <TopToolbar>
    <ListButton
      basePath={basePath}
      label='ra.action.back'
      icon={<ChevronLeft />}
    />
  </TopToolbar>
);

const ReferenceTypeCreate = (props: any) => {
  return (
    <Create actions={<ReferenceTypeActions {...props} />} {...props}>
      <ReferenceTypeForm />
    </Create>
  );
};

export default ReferenceTypeCreate;
